import React, { Component } from 'react'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import FlatButton from 'material-ui/FlatButton'
import Delete from 'material-ui/svg-icons/action/delete'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import Paper from 'material-ui/Paper'
import Modal from './Modals'
import Snackbar from 'material-ui/Snackbar'
import IconButton from 'material-ui/IconButton'
import EditIcon from 'material-ui/svg-icons/editor/mode-edit'
import { Link, Redirect } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { getToken } from '../../../lib'
import images from '../../../config/images'

export default class ListName extends Component {
  state = {
    rows: [1, 2, 3, 4, 5],
    selectedRows: [],
    open: false,
    user: null,
    snackbarOpen: false,
    snackbarMessage: '',
    listModalOpen: false,
    listModalPurpose: null,
    isEmpty: false,
    singleIconClick: false,
    username: null,
    userEmail: null,
    role: 'student',
    listId: null
  }

  componentDidMount () {
    if (this.props.location.state) {
      const {id} = this.props.location.state
      const token = getToken()
      this.props.fetchListDetails(token, id)
    }
  }

  handleSendTouch = (e, message, purpose) => {
    this.setState({
      singleIconClick: true
    })
    if (purpose === 'delete') {
      e.target.style.fill = e.target.style.fill === 'red' ? '#afb8c5' : 'red'
    }
  }

  editDetails = (name, email, role, listId) => {
    this.setState({
      singleIconClick: true,
      username: name,
      userEmail: email,
      role,
      listModalPurpose: 'editPerson',
      listModalOpen: true,
      listId
    })
  }

  handleDeleteTouch = (e, message, listId) => {
    const {id} = this.props.location.state
    const token = getToken()
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: message
    })
    e.target.style.fill = e.target.style.fill === 'red' ? '#afb8c5' : 'red'
    this.props.deletePerson(token, listId, id)
  }

  handleDeleteMultiple = (e, message) => {
    const {id} = this.props.location.state
    const {selectedRows} = this.state
    const token = getToken()
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: message
    })
    this.props.list.map((val, index) => {
      if (selectedRows.indexOf(index) !== -1) {
        this.props.deletePerson(token, val.id, id)
      }
    })
  }

  handleClose = () => this.setState({open: false})

  handleTouchTap = () => {
    this.setState({
      snackbarOpen: true,
      open: false,
      snackbarMessage: (
        <div>
          {this.state.user}
          <FormattedMessage id="seminarActions.removedMessage"/>
        </div>
      )
    })
  }

  handleRequestClose = () => this.setState({snackbarOpen: false})

  hadleListClick = (e, purpose) =>
    this.setState({listModalOpen: true, listModalPurpose: purpose})

  handleListModalClose = () => this.setState({listModalOpen: false})

  getSnackbarDetails = message => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message
    })
  }

  handleRowSelection = row => {
    if (!this.state.singleIconClick) {
      if (row === 'all') {
        let arr = []
        this.props.list.map((val, index) => {
          arr[index] = index
        })
        this.setState({selectedRows: arr})
      } else if (row === 'none') {
        this.setState({selectedRows: []})
      } else {
        this.setState({selectedRows: row})
      }
    } else {
      this.setState({singleIconClick: false})
    }
  }

  removeAll = message => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message,
      isEmpty: true
    })
  }

  render () {
    const {username, userEmail, role, listId} = this.state
    if (this.props.location.state) {
      return (
        <div>
          <div className="flex items-center mb4">
            <Link
              to={'/admin/contacts'}
              className="link"
            >
              <span
                className="pr2"
                style={{fontSize: 24, color: '#6B7C93', opacity: 0.37}}
              >
                <FormattedMessage id="contacts.list"/>
              </span>
            </Link>
            <Arrow className="pr2" style={{fill: '#c6ced7'}}/>
            <span style={{fontSize: 24, color: '#6B7C93'}}>
              {this.props.match.params.name}
            </span>
          </div>
          <Paper className="pa3">
            <div className="flex justify-end mb3">
              <FlatButton
                onTouchTap={e => this.hadleListClick(e, 'csvImport')}
                backgroundColor="#ecedef"
                label={<FormattedMessage id="contacts.csvImport"/>}
                labelStyle={{color: '#4688F1'}}
              />
              <FlatButton
                onTouchTap={e => this.hadleListClick(e, 'editName')}
                backgroundColor="#ecedef"
                style={{marginLeft: '1rem'}}
                label={<FormattedMessage id="contacts.edit"/>}
                labelStyle={{color: '#4688F1'}}
              />
              <FlatButton
                onTouchTap={e => this.hadleListClick(e, 'deleteList')}
                backgroundColor="#ecedef"
                style={{marginLeft: '1rem'}}
                label={<FormattedMessage id="contacts.delete"/>}
                labelStyle={{color: '#4688F1'}}
              />
              <FlatButton
                onTouchTap={e => this.hadleListClick(e, 'addPerson')}
                backgroundColor="#ecedef"
                style={{marginLeft: '1rem'}}
                label={<FormattedMessage id="contacts.add"/>}
                labelStyle={{color: '#4688F1'}}
              />
            </div>
            <Table
              selectedColor="black"
              style={{tableLayout: 'auto', border: '1px solid #d9d9d9'}}
              fixedHeader={!(this.state.selectedRows.length === 0)}
              height={
                this.props.isFetchingListDetails || this.props.list.length === 0
                  ? ''
                  : '50vh'
              }
              onRowSelection={this.handleRowSelection}
              multiSelectable={this.props.list.length !== 0}
            >
              <TableHeader
                style={
                  this.state.selectedRows.length === 0
                    ? {
                      backgroundColor: '#ecedef'
                    }
                    : {
                      backgroundColor: '#FFFFFF'
                    }
                }
              >
                {this.state.selectedRows.length === 0 ? (
                  <TableRow>
                    <TableHeaderColumn
                      style={{fontSize: 14, color: '#6B7C93'}}
                    >
                      <FormattedMessage id="inviteModal.recording.name"/>
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      style={{fontSize: 14, color: '#6B7C93'}}
                    >
                      <FormattedMessage id="seminarActions.tableHeading.email"/>
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      style={{fontSize: 14, color: '#6B7C93'}}
                    >
                      <FormattedMessage id="contacts.role"/>
                    </TableHeaderColumn>
                    <TableHeaderColumn>
                      <div/>
                    </TableHeaderColumn>
                  </TableRow>
                ) : (
                  <TableRow selectable={false}>
                    <TableHeaderColumn
                      style={{fontSize: 14, color: '#6B7C93'}}
                    >
                      {this.state.selectedRows.length}
                      <FormattedMessage id="contacts.selected"/>
                    </TableHeaderColumn>
                    <TableHeaderColumn>
                      <div className="flex items-center justify-end">
                        <FlatButton
                          style={{paddingLeft: '1rem', paddingRight: '1rem'}}
                          onTouchTap={e =>
                            this.handleDeleteMultiple(
                              e,
                              <div>
                                {this.state.selectedRows.length}
                                <FormattedMessage id="contacts.removed"/>
                              </div>
                            )}
                          touchRippleColor="red"
                        >
                          <div className="flex items-center justify-between">
                            <Delete style={{fill: '#F01631'}}/>
                            <div className="pl3" style={{color: '#F01631'}}>
                              <FormattedMessage id="contacts.remove"/>
                            </div>
                          </div>
                        </FlatButton>
                      </div>
                    </TableHeaderColumn>
                  </TableRow>
                )}
              </TableHeader>
              {!this.props.isFetchingListDetails &&
              this.props.list.length >= 1 ? (
                <TableBody deselectOnClickaway={false}>
                  {this.props.list.map((val, index) => (
                    <TableRow
                      key={index}
                      onClick={this.handleSendTouch}
                      onCellClick={this.handleDeleteTouch}
                      selected={this.state.selectedRows.indexOf(index) !== -1}
                    >
                      <TableRowColumn
                        style={{fontSize: 14, color: '#6B7C93'}}
                      >
                        {val.name}
                      </TableRowColumn>
                      <TableRowColumn
                        style={{fontSize: 14, color: '#6B7C93'}}
                      >
                        {val.email}
                      </TableRowColumn>
                      <TableRowColumn
                        style={{fontSize: 14, color: '#6B7C93'}}
                      >
                        <div className="flex items-center h-100">
                          <div className="pl2"> {val.role === 'teacher' ? (
                            <FormattedMessage id="inviteModal.teacher"/>
                          ) : val.role === 'facilitator' ? (
                            <FormattedMessage id="inviteModal.facilitator"/>
                          ) : (
                            <FormattedMessage id="inviteModal.student"/>
                          )}
                          </div>
                        </div>
                      </TableRowColumn>
                      <TableRowColumn
                        style={{
                          fontSize: 14,
                          color: '#6B7C93',
                          overflow: 'visible'
                        }}
                      >
                        {this.state.selectedRows.indexOf(index) === -1 ? (
                          <div className="flex justify-end">
                            <IconButton
                              onTouchTap={e =>
                                this.editDetails(
                                  val.name,
                                  val.email,
                                  val.role,
                                  val.id
                                )}
                              iconStyle={{fill: '#afb8c5'}}
                              tooltip={
                                <FormattedMessage id="contacts.tooltipEdit"/>
                              }
                            >
                              <EditIcon/>
                            </IconButton>
                            <IconButton
                              onTouchTap={e =>
                                this.handleDeleteTouch(
                                  e,
                                  <div>
                                    {val.name}
                                    <FormattedMessage id="seminarActions.singleRemoved"/>
                                  </div>,
                                  val.id
                                )}
                              iconStyle={{fill: '#afb8c5'}}
                              touchRippleColor="red"
                              tooltip={
                                <FormattedMessage id="contacts.tooltipRemove"/>
                              }
                            >
                              <Delete/>
                            </IconButton>
                          </div>
                        ) : (
                          ''
                        )}
                      </TableRowColumn>
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody/>
              )}
            </Table>
            {this.props.isFetchingListDetails ? (
              <div
                style={{height: '40vh'}}
                className="flex justify-center items-center"
              >
                Fetching List Details...
              </div>
            ) : this.props.list.length === 0 ? (
              <div
                style={{backgroundColor: '#f2f3f6', height: '40vh'}}
                className="flex justify-center items-center"
              >
                <div
                  style={{width: '544px'}}
                  className="flex flex-column justify-center items-center"
                >
                  <div
                    className="tc mb4"
                    style={{fontSize: 16, color: '#6B7C93'}}
                  >
                    <FormattedMessage id="seminarActions.noParticipants"/>
                  </div>
                  <div className="mb4">
                    <img
                      style={{height: 80, width: 80}}
                      src={images.inviteUserBigIcon}
                      alt="user"
                    />
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
          </Paper>
          {false && <Snackbar
            style={{left: 200, bottom: 30}}
            open={this.state.snackbarOpen}
            message={this.state.snackbarMessage}
            action={<FormattedMessage id="seminarActions.dismiss"/>}
            onActionTouchTap={this.handleRequestClose}
            autoHideDuration={4000}
            onRequestClose={this.handleRequestClose}
          />}
          <Modal
            fetchListDetails={this.props.fetchListDetails}
            csvUpload={this.props.csvUpload}
            location={this.props.location.pathname}
            deleteContactList={this.props.deleteContactList}
            name={this.props.match.params.name}
            updateContactList={this.props.updateContactList}
            editPerson={this.props.editPerson}
            contactId={this.props.location.state.id}
            addPerson={this.props.addPerson}
            purpose={this.state.listModalPurpose}
            open={this.state.listModalOpen}
            handleClose={this.handleListModalClose}
            snackbarOpen={this.getSnackbarDetails}
            user={{username, userEmail, role, listId}}
            removeAll={this.removeAll}
          />
        </div>
      )
    }

    return (
      <Redirect
        to={'/admin/contacts'}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Contacts/ListName/ListName.js